var _rect, _rect2, _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionMap4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 122,
    viewBox: "0 0 225 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.84122,
    y: 1.84122,
    width: 153.318,
    height: 118.318,
    fill: "#C6DD35",
    fillOpacity: 0.4,
    stroke: "#DADD35",
    strokeWidth: 3.68244
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_397",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 157,
    height: 122
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 122,
    fill: "#6BDD35"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_397)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 18,
    r: 18,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 21,
    r: 18,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 18,
    r: 18,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 16,
    r: 29,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 18,
    r: 29,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 20,
    r: 29,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 27,
    r: 29,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 18,
    r: 29,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 21,
    r: 29,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 23,
    r: 29,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 27,
    r: 29,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.5,
    cy: 113.5,
    r: 26.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 107.5,
    r: 26.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 103.5,
    r: 26.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 103.5,
    r: 19.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.5,
    cy: 102.5,
    r: 19.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.5,
    cy: 108.5,
    r: 19.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 108.5,
    r: 19.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 108.5,
    r: 19.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 92.5,
    r: 11.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 87.5,
    r: 11.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 86.5,
    r: 11.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 85.5,
    r: 14.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 84.5,
    r: 14.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 82.5,
    r: 14.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 78.5,
    r: 14.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 78.5,
    r: 14.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 100.5,
    r: 14.5,
    fill: "#8D9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 18,
    r: 18,
    fill: "#8D9534",
    fillOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.016 18.5312C198.359 18.5391 200.578 19.9375 200.578 24.0469C200.586 27.8906 198.766 30.1562 195.922 30.1562C193.648 30.1562 192.086 28.7266 191.859 26.8125H194.172C194.367 27.6484 195.016 28.1406 195.922 28.1406C197.461 28.1406 198.273 26.7578 198.281 24.5H198.188C197.656 25.5 196.539 26.0938 195.281 26.0938C193.25 26.0938 191.75 24.5625 191.734 22.4531C191.734 20.1797 193.461 18.5234 196.016 18.5312ZM194.031 22.3906C194.031 23.5078 194.852 24.375 196.016 24.375C197.164 24.375 198.047 23.4609 198.047 22.375C198.031 21.2969 197.188 20.3828 196.031 20.375C194.875 20.3828 194.016 21.2656 194.031 22.3906ZM207.047 18.6875V30H204.688V20.9219H204.625L202.031 22.5469V20.4688L204.828 18.6875H207.047ZM212.641 24.3438C210.945 24.3438 210.031 23.1094 210.031 21.3281C210.031 19.5391 210.992 18.2969 212.641 18.2969C214.336 18.2969 215.242 19.5391 215.25 21.3281C215.242 23.125 214.312 24.3438 212.641 24.3438ZM211.625 21.3281C211.633 22.3047 211.984 22.9453 212.641 22.9531C213.312 22.9453 213.648 22.3047 213.656 21.3281C213.648 20.3516 213.344 19.6875 212.641 19.6875C211.977 19.6953 211.633 20.3672 211.625 21.3281ZM211.656 30L219.438 18.6875H221.188L213.406 30H211.656ZM217.672 27.3594C217.672 25.5703 218.633 24.3359 220.266 24.3281C221.977 24.3359 222.883 25.5703 222.891 27.3594C222.883 29.1562 221.953 30.375 220.266 30.375C218.586 30.375 217.672 29.1406 217.672 27.3594ZM219.266 27.3594C219.273 28.3359 219.625 28.9844 220.266 28.9844C220.953 28.9844 221.289 28.3359 221.297 27.3594C221.289 26.3828 220.977 25.7188 220.266 25.7344C219.609 25.7266 219.273 26.3984 219.266 27.3594Z",
    fill: "#CDD0DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.585 96.248C197.533 96.2627 199.577 97.4346 199.584 101.316C199.584 105.037 197.98 107.146 195.438 107.146C193.483 107.146 192.121 105.938 191.864 104.217H193.461C193.681 105.11 194.369 105.733 195.438 105.74C197.072 105.733 198.031 104.312 198.046 101.888H197.914C197.343 102.781 196.347 103.323 195.204 103.323C193.3 103.323 191.776 101.866 191.776 99.8369C191.776 97.8154 193.278 96.2334 195.585 96.248ZM193.344 99.8076C193.351 101.038 194.267 102.012 195.556 102.005C196.837 102.012 197.826 100.965 197.826 99.793C197.826 98.6431 196.881 97.5957 195.585 97.5957C194.303 97.5957 193.336 98.5918 193.344 99.8076ZM203.715 101.434C202.265 101.448 201.474 100.372 201.488 98.7969C201.474 97.2441 202.301 96.1675 203.715 96.1748C205.172 96.1675 205.934 97.2441 205.941 98.7969C205.934 100.379 205.143 101.448 203.715 101.434ZM202.689 107L209.97 96.3945H211.303L204.022 107H202.689ZM202.689 98.7969C202.697 99.771 203.034 100.401 203.715 100.408C204.403 100.401 204.726 99.771 204.726 98.7969C204.726 97.8447 204.425 97.1929 203.715 97.2002C203.034 97.2148 202.697 97.8521 202.689 98.7969ZM208.183 104.583C208.175 103.016 208.996 101.939 210.409 101.946C211.859 101.939 212.628 103.016 212.636 104.583C212.628 106.15 211.837 107.22 210.409 107.22C208.966 107.22 208.175 106.143 208.183 104.583ZM209.384 104.583C209.391 105.542 209.728 106.18 210.409 106.18C211.098 106.18 211.42 105.542 211.42 104.583C211.42 103.616 211.12 102.972 210.409 102.972C209.735 102.986 209.391 103.624 209.384 104.583Z",
    fill: "#CDD0DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.333 25C178.333 26.4727 179.527 27.6667 181 27.6667C182.473 27.6667 183.667 26.4727 183.667 25C183.667 23.5272 182.473 22.3333 181 22.3333C179.527 22.3333 178.333 23.5272 178.333 25ZM53.3333 25C53.3333 26.4728 54.5272 27.6667 56 27.6667C57.4728 27.6667 58.6667 26.4728 58.6667 25C58.6667 23.5272 57.4728 22.3333 56 22.3333C54.5272 22.3333 53.3333 23.5272 53.3333 25ZM181 24.5L56 24.5L56 25.5L181 25.5L181 24.5Z",
    fill: "#CDD0DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.333 102C177.333 103.473 178.527 104.667 180 104.667C181.473 104.667 182.667 103.473 182.667 102C182.667 100.527 181.473 99.3333 180 99.3333C178.527 99.3333 177.333 100.527 177.333 102ZM123.333 102C123.333 103.473 124.527 104.667 126 104.667C127.473 104.667 128.667 103.473 128.667 102C128.667 100.527 127.473 99.3333 126 99.3333C124.527 99.3333 123.333 100.527 123.333 102ZM180 101.5L126 101.5L126 102.5L180 102.5L180 101.5Z",
    fill: "#CDD0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionMap4);
export default __webpack_public_path__ + "static/media/Section_map_4.67276459aa835810be76b04d246223d6.svg";
export { ForwardRef as ReactComponent };